module.exports = "<captain-invoices-page></captain-invoices-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/captainInvoices.html
// module id = 1707
// module chunks = 0